import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { GeneralService } from '~src/app/modules/services/general.service';

@Component({
  selector: 'app-ott-expired',
  templateUrl: './ott-expired.component.html',
  styleUrls: ['./ott-expired.component.css'],
  imports: [CommonModule],
})
export class OttExpiredComponent {
    ottStatus: string = 'missing';
    constructor(
        private generalService: GeneralService,
    ) { }
    ngOnInit(): void {
        this.ottStatus = this.generalService.ottStatus;
    }
}
